// ====================
// > Buy
// ====================
const setCheckinKey = (state, checkinKey) => {
  state.checkinKey = checkinKey
}

const clearCheckinKey = (state) => {
  state.checkinKey = null
}

const setSignature = (state, signature) => {
  state.buy.signature = signature
}

const setBuy = (state, buy) => {
  state.buy = buy
}

const setAddressIsPrepopulated = (state, bool) => {
  state.addressIsPrepopulated = bool
}

// ====================
// > Store
// ====================
const setWinmarkStore = (state, winmarkStore) => {
  state.winmarkStore = winmarkStore
  if (winmarkStore.rai_store) {
    state.raiStore = winmarkStore.rai_store
  }
}

const setRaiStore = (state, raiStore) => {
  state.raiStore = raiStore
  if (this.$ga) {
    try {
      this.$ga.set('store_number', raiStore.store_number)
    } catch (error) {
      console.log(error)
    }
  }
}

export default {
  setCheckinKey,
  clearCheckinKey,
  setBuy,
  setSignature,
  setWinmarkStore,
  setRaiStore,
  setAddressIsPrepopulated
}



// WEBPACK FOOTER //
// ./src/store/mutations.js